import React, { useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import { Lock, X, UserCog, PieChart, Upload, BarChart3, Heart } from 'lucide-react';
import PasswordChange from './PasswordChange';
import UserManagement from './UserManagement';
import CustomerImport from './CustomerImport';
import OfferInterestList from './OfferInterestList';
import Statistics from './Statistics'; // Importa il nuovo componente
import JKStatistics from './JKStatistics'; // Importa il componente per le statistiche JK

const UserPanel = ({ onClose }) => {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('password');

  // Tab definitions with role-based access
  const tabs = [
    {
      id: 'password',
      label: 'Passwort ändern',
      icon: <Lock className="h-5 w-5" />,
      roles: ['admin', 'agent', 'jk_manager', 'user'], // Alle Rollen können das Passwort ändern
      component: <PasswordChange />
    },
    {
      id: 'users',
      label: 'Benutzerverwaltung',
      icon: <UserCog className="h-5 w-5" />,
      roles: ['admin'], // Nur Admin kann Benutzer verwalten
      component: <UserManagement />
    },
    {
      id: 'customer-import',
      label: 'Kunden Import',
      icon: <Upload className="h-5 w-5" />,
      roles: ['admin'], // Nur Admin kann Kunden importieren
      component: <CustomerImport />
    },
    {
      id: 'offer-interests',
      label: 'Angebot-Interessenten',
      icon: <Heart className="h-5 w-5" />,
      roles: ['admin'],
      component: <OfferInterestList />
    },
    {
      id: 'statistics',
      label: 'Statistiken',
      icon: <PieChart className="h-5 w-5" />,
      roles: ['admin', 'agent', 'user'], // JK Manager non vede le statistiche legacy
      component: <Statistics />
    },
    {
      id: 'jk-statistics',
      label: 'Statistiken',
      icon: <BarChart3 className="h-5 w-5" />,
      roles: ['jk_manager'], // Solo JK Manager può vedere le statistiche
      component: <JKStatistics />
    }
  ];
  // Filter tabs based on user role
  const allowedTabs = tabs.filter(tab => 
    user && tab.roles.includes(user.role.toLowerCase())
  );

  // Set first allowed tab as active if current active tab is not allowed
  if (allowedTabs.length > 0 && !allowedTabs.some(tab => tab.id === activeTab)) {
    setActiveTab(allowedTabs[0].id);
  }

  if (!user) {
    return <div>Lädt...</div>;
  }

  return (
    <div className="max-w-full">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-bold text-gray-900">Benutzerprofil</h2>
        {onClose && (
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-500 focus:outline-none"
            aria-label="Schließen"
          >
            <X className="h-6 w-6" />
          </button>
        )}
      </div>

      <div className="bg-white rounded-lg overflow-hidden">
        <div className="sm:flex">
          {/* Sidebar on larger screens */}
          <div className="bg-gray-50 p-4 sm:w-64 sm:border-r border-gray-200">
            <div className="flex items-center mb-8 p-2 bg-indigo-50 rounded-lg">
              <div className="w-10 h-10 bg-indigo-600 rounded-full flex items-center justify-center text-white">
                {user.username.charAt(0).toUpperCase()}
              </div>
              <div className="ml-3">
                <div className="font-semibold">{user.username}</div>
                <div className="text-sm text-gray-500">
                  {user.role === 'admin' ? 'Administrator' : 
                   user.role === 'agent' ? 'Agent' : 
                   user.role === 'jk_manager' ? 'JK Manager' : 
                   user.role === 'user' ? 'Benutzer' : user.role}
                </div>
              </div>
            </div>
            
            <nav className="space-y-1">
              {allowedTabs.map((tab) => (
                <button
                  key={tab.id}
                  className={`w-full flex items-center px-3 py-2 text-sm font-medium rounded-md ${
                    activeTab === tab.id
                      ? 'bg-indigo-100 text-indigo-700'
                      : 'text-gray-600 hover:bg-gray-100'
                  }`}
                  onClick={() => setActiveTab(tab.id)}
                >
                  <span className="mr-3">{tab.icon}</span>
                  {tab.label}
                </button>
              ))}
            </nav>
          </div>

          {/* Main content area */}
          <div className="flex-1 min-w-0 overflow-auto">
            {allowedTabs.find(tab => tab.id === activeTab)?.component}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserPanel;